import { getClient } from '../../../lib/sanity.server';
import { groq } from 'next-sanity';
import { GetStaticPaths, GetStaticProps, NextPage } from 'next';
import { WhatsNew } from '.';
import SanityBody from '../../../components/SanityBody';
import React from 'react';
import GrayLink from '../../../components/GrayLink';
import AngleButton from '../../../components/AngleButton';

const WhatsNewArticle: NextPage<{ post: WhatsNew }> = ({ post }) => {
  return (
    <div>
      <div className='mt-32 body-paragraph text-gray-50'>
        <GrayLink link='/learn' text='Learn' /> /&nbsp;
        <GrayLink link='/learn/whats-new' text="What's new" />
      </div>
      <h1 className='mt-2'>{post.title}</h1>
      <SanityBody body={post.body} />
      <div className='mt-12 mb-24'>
        <AngleButton text='See all updates' link='/learn/whats-new' />
      </div>
    </div>
  );
};

export const getStaticPaths: GetStaticPaths<{ slug: string }> = async () => {
  const paths = await getClient().fetch<Array<string>>(groq`
    *[_type == 'whatsNew' && defined(slug.current)][].slug.current
  `);

  return {
    paths: paths.map(slug => ({ params: { slug } })),
    fallback: 'blocking',
  };
};

export const getStaticProps: GetStaticProps<{ post: WhatsNew }> = async ({
  params,
  preview = false,
}) => {
  const post = await getClient(preview).fetch<WhatsNew>(
    groq`
    *[_type == "whatsNew" && slug.current == $slug][0] {
      "slug": slug.current,
      body[]{
        ...,
        _type == "reference"=>^->
      },
      title,
      excerpt
    }
  `,
    {
      slug: params?.slug,
    }
  );

  if (!post) {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      post,
    },
  };
};

export default WhatsNewArticle;
